<template>
  <v-row class="text-left full-height">
    <v-col cols="12">
      <v-card flat class="my-2 ml-3 mr-2">
        <v-row>
          <v-col cols="12" class="px-0">
            <v-form v-model="form.validColorInfo" onSubmit="return false;" class="full-width">
              <v-card-title>Color Options</v-card-title>
              <v-card-text>
                <v-row class="full-width px-4 mt-3">
                  <v-col cols="12" sm="12" md="6" class="px-0 pt-0">
                    <div class="d-flex align-start">
                      <v-text-field
                        dense
                        outlined
                        v-model="primaryColor"
                        label="Primary brand color (in hexadecimal)"
                        :rules="[
                          (v) =>
                            !!(!v || (v && v.startsWith('#'))) ||
                            'Your hex color value should start with #',
                          (v) =>
                            !!(!v || (v && v.length == 7)) ||
                            'Your hex color value should be 6 characters',
                        ]"
                      ></v-text-field>
                      <input
                        type="color"
                        id="html5colorpicker"
                        v-model="primaryColor"
                        style="width: 15%; margin-left: 5px; margin-top: 6px"
                      />
                    </div>
                    <div class="d-flex align-start">
                      <v-text-field
                        dense
                        outlined
                        v-model="secondaryColor"
                        label="Secondary brand color (in hexadecimal)"
                        :rules="[
                          (v) =>
                            !!(!v || (v && v.startsWith('#'))) ||
                            'Your hex color value should start with #',
                          (v) =>
                            !!(!v || (v && v.length == 7)) ||
                            'Your hex color value should be 6 characters',
                        ]"
                      ></v-text-field>
                      <input
                        type="color"
                        id="html5colorpicker"
                        v-model="secondaryColor"
                        style="width: 15%; margin-left: 5px; margin-top: 6px"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
          </v-col>
        </v-row>
        <div class="d-flex justify-center flex-column align-center">
          <v-btn
            @click="handleSave"
            :disabled="!form.validColorInfo"
            :loading="loading.general"
            depressed
            rounded
            color="brandCyan"
            class="white--text my-4"
            >Save Changes</v-btn
          >
          <p v-if="error.general" class="error--text">
            {{ error.general }}
          </p>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ClientService from "@/services/ClientServiceV2";

import { formRules } from "@/shared_data/data";

import { mapState } from "vuex";

function initialState() {
  return {
    clientService: new ClientService(),

    // Client info
    primaryColor: null,
    secondaryColor: null,

    // Static
    formRules,

    // Dialogs, API, and forms
    snackbarText: "Copied URL to clipboard",
    dialog: {
      snackbar: false,
      imageSelector: false,
      imageCropper: false,
    },
    form: {
      validOnboardingLink: true,
      validColorInfo: true,
    },
    error: {
      general: null,
    },
    loading: {
      general: false,
    },
  };
}
export default {
  name: "ClientColorManager",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      required: false,
    },
  },
  components: {},
  data() {
    return initialState();
  },
  created() {
    this.loadClient();
  },
  beforeUnmount() {},
  methods: {
    resetPage() {
      Object.assign(this.$data, initialState());
    },
    loadClient() {
      this.resetPage();

      if (!this.client) {
        console.error("Client not found", this.globalClientId);
        return;
      }
      console.log("Loading client", this.client);

      const { clientId, primaryColor, secondaryColor } = this.client;

      this.clientId = clientId;
      this.primaryColor = primaryColor;
      this.secondaryColor = secondaryColor;

      // The html color picker will contain an empty string if the user manually entered/deleted the hex color
      if (this.primaryColor == "") this.primaryColor = null;
      if (this.secondaryColor == "") this.secondaryColor = null;
    },
    async handleSave() {
      if (!this.form.validColorInfo) return;

      try {
        this.loading.general = true;
        this.error.general = null;

        let body = {
          primaryColor: this.primaryColor,
          secondaryColor: this.secondaryColor,
        };

        await this.clientService.updateClientV3(this.clientId, body);

        console.log("color options saved", this.clientId);

        await this.$emit("getClient", { clientId: this.clientId });
      } catch (e) {
        this.error.general = e.message || "Failed to save options";
      } finally {
        this.loading.general = false;
      }
    },

    resetState() {
      this.primaryColor = null;
      this.secondaryColor = null;
    },
  },
  computed: {
    ...mapState(["userProfile", "clients", "globalClientId"]),
  },
  watch: {
    client: {
      handler() {
        console.log("client changed", this.client);
        this.loadClient();
      },
    },
  },
};
</script>

<style scoped></style>
